import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Link from 'components/Link';
import TeasePicture from 'components/TeasePicture';
import TypeIcon from 'components/TypeIcon';
import Unibrow from 'components/Unibrow';

import AIMS_FLAVORS from 'lib/aimsFlavors';
import {
  content as ContentPropType,
  packageContext as packageContextTypes,
} from 'lib/CustomPropTypes';
import { imageAltForItem } from 'lib/imageAlt';
import { getTeaseUrl } from 'lib/teaseUtils';
import { getVerticalName } from 'lib/verticalType';

function renderHeadline(headline) {
  return (
    <h2 className="a-la-carte__headline" data-test="a-la-carte__headline">
      {headline}
    </h2>
  );
}

function renderImage(src, url, type, alt) {
  return (
    <div className="a-la-carte__image-wrapper" data-test="a-la-carte__image-wrapper">
      <Link to={url}>
        <TypeIcon type={type} className="a-la-carte__type-icon" />
        <TeasePicture
          className="a-la-carte__image"
          url={src}
          responsiveFlavors={{
            s: AIMS_FLAVORS.FOCAL_80x80,
          }}
          alt={alt}
          retina
        />
      </Link>
    </div>
  );
}

function renderUnibrow(unibrow, isOpinion) {
  return (
    <Unibrow
      unibrow={unibrow}
      className={classNames(
        'a-la-carte__unibrow',
        'mt0 f2 fw1 founders-mono lh-none ttu',
        {
          'a-la-carte__unibrow--opinion': isOpinion,
        },
      )}
      data-test="a-la-carte__unibrow"
    />
  );
}

function ALaCarteItem(props) {
  const { item } = props;

  const {
    computedValues,
    id,
    type,
    metadata,
  } = item;

  const {
    headline,
    url,
    unibrow,
  } = computedValues || {};

  const itemVerticalSource = getVerticalName(item);
  const isOpinion = itemVerticalSource === 'think';

  // every tease is 1x1 across verticals for A La Carte
  // this will not be true when integrated with Tease List for non-TODAY brands
  const isSquareImage = true;
  const imageUrl = getTeaseUrl(item, isSquareImage);
  const shouldDisplayImage = !!imageUrl && metadata.showTeaseImage !== false;
  const imageAlt = imageAltForItem(item);


  return (
    <li
      key={id}
      data-contentid={id}
      className={
        classNames(
          'a-la-carte__item',
          {
            'a-la-carte__item--no-art': !shouldDisplayImage,
            'df justify-start': shouldDisplayImage,
          },
        )
      }
      data-test="a-la-carte__item"
    >
      {shouldDisplayImage && renderImage(imageUrl, url, type, imageAlt)}
      <div className={classNames({ ml3: shouldDisplayImage })}>
        {shouldDisplayImage && renderUnibrow(unibrow, isOpinion)}
        <Link to={url}>{renderHeadline(headline)}</Link>
      </div>
    </li>
  );
}

ALaCarteItem.propTypes = {
  item: ContentPropType.isRequired,
};

ALaCarteItem.contextTypes = {
  vertical: PropTypes.string,
  ...packageContextTypes,
};

export default ALaCarteItem;
